export enum ProjectInfo {
  New = "NEW",
  Old = "OLD",
}
